import React, { useState, useEffect, useRef } from "react";
import { Formik } from "formik";
import Select from "react-select";
import {
  updateUserPrefrences,
  requestScreenNameChange,
} from "../../../../services/profile";
import { setLoading } from "../../../../reducer/auth/auth";
import { useDispatch } from "react-redux";
import { removeItemOnce } from "../../../../utils/helpers";
import { toast } from "react-toastify";
import Button from "../../../../components/button";
import { useTranslation } from "react-i18next";

export default function Preferences(props) {
  const { t } = useTranslation("mediumProfile");
  const dispatch = useDispatch();
  const {
    stepTwoData,
    countryData,
    tools,
    stepOneData,
    getPreferences,
  } = props;
  const [newToolsData, setNewToolsData] = useState([]);
  const [mediumshipLevel, setMediumshipLevel] = useState(stepOneData);
  const [newCountryData, setNewCountryData] = useState([]);
  const [requestChange, setRequestChange] = useState(false);
  const [newScreenName, setNewScreenName] = useState("");
  const [
    requestChangeSuceessMessage,
    setrequestChangeSuceessMessage,
  ] = useState("");

  const toolsRef = useRef(null);
  const rolesRef = useRef(null);
  const allowRecordingsRef = useRef(null);
  const countriesRef = useRef(null);
  const sessionTypeRef = useRef(null);

  // Status messages are kept in English in state (they are compared in code)
  // and only translated when displayed.
  const messageKeys = {
    "You have successfully submited Request for screen name change":
      "preferences.messages.screenNameChangeSubmitted",
    "Screen name is required": "preferences.messages.screenNameRequired",
  };
  const translateMessage = (message) =>
    message && messageKeys[message]
      ? t(messageKeys[message], { defaultValue: message })
      : message;

  useEffect(() => {
    setNewToolsData(
      tools.map((item) => {
        return {
          ...item,
          value: item.id,
          label: item.tools_name,
        };
      })
    );
    setNewCountryData(
      countryData.map((item) => {
        return {
          ...item,
          value: item.id,
          label: item.country_name,
        };
      })
    );
  }, ["", countryData, tools]);
  useEffect(() => {
    setMediumshipLevel(stepOneData);
  }, [stepOneData]);
  const getCountryTypes = (type, exclusions, inclusions) => {
    console.log(type, exclusions, newCountryData);
    let country;
    if (type === "All Countries") {
      country = newCountryData.map((item) => {
        return item.id;
      });
    }
    if (type === "All Countries with Exclusions") {
      let itemArray = [];
      // console.log(exclusions,'exclusion aakash')
      // console.log(newCountryData,'country data aakash')

      newCountryData.map((item, index) => {
        itemArray.push(item.id);
      });
      exclusions.map((item, index) => {
        itemArray = removeItemOnce(itemArray, item.id);
      });
      country = itemArray;
    }
    if (type === "Selected Countries only") {
      country = inclusions.map((item) => {
        return item.id;
      });
    }
    console.log(country, "country");
    return country;
  };
  const RunFunction = (formData) => {
    dispatch(setLoading(true));
    // setValues(formData);
    const {
      mediumship_session_tools,
      currentRoles,
      screenName,
      allowRecordings,
      wantToDoSessions,
      wantToDoWork,
      exclusions,
      inclusions,
      interestedSessionType,
      interestedSessionType1,
      PaymentMethods,
      opt_in,
    } = formData;
    let tools = mediumship_session_tools.map((item) => {
      return item.id;
    });
    let countryType = getCountryTypes(wantToDoWork, exclusions, inclusions);

    let item = {
      user_id: 1,
      mediumship_session_tools: tools,
      current_roles: currentRoles,
      screen_name: screenName,
      allow_recordings: allowRecordings,
      // session_preferences: wantToDoSessions,

      client_session_preferences: wantToDoSessions,
      session_message: interestedSessionType1,
      session_type: interestedSessionType,
      countries: countryType,
      payment_methods: PaymentMethods,
      country_type: wantToDoWork,
      opt_in: opt_in === "Yes" ? 1 : 0,
    };
    updateUserPrefrences(item)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          toast.success(t("toast.profileUpdated"), { position: "top-center" });
          getPreferences();
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };
  const changeHandler = (value, setFieldValue) => {
    let tool = value;
    if (value.length > 1 && value[0].tools_name === "None") {
      tool.shift();
    }
    const checkToolname = (obj) => obj.tools_name === "None";
    if (value.some(checkToolname)) {
      value.map((item) => {
        if (item.tools_name === "None") {
          tool = [item];
        }
      });
    }
    setFieldValue("mediumship_session_tools", tool);
  };

  const requestChangeHandler = () => {
    setRequestChange(true);

    setrequestChangeSuceessMessage("");
    if (requestChange) {
      if (newScreenName !== "") {
        let body = {
          type: "screen_name",
          value: newScreenName,
        };
        requestScreenNameChange(body)
          .then((data) => {
            if (data.data.status) {
              setrequestChangeSuceessMessage(
                "You have successfully submited Request for screen name change"
              );
            }
          })
          .catch(() => {});
      } else {
        setrequestChangeSuceessMessage("Screen name is required");
      }
    }
  };
  const handleChangeScreenNameHandler = (e) => {
    setNewScreenName(e.target.value);
  };

  const showFormErrors = (errors) => {
    if (Object.keys(errors).length > 0) {
      toast.error(t("toast.completeRequired"), {
        position: "top-center",
      });
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  };

  const focusFirstInvalidField = (errors) => {
    const fieldOrder = [
      { key: "mediumship_session_tools", ref: toolsRef },
      { key: "currentRoles", ref: rolesRef },
      { key: "allowRecordings", ref: allowRecordingsRef },
      { key: "exclusions", ref: countriesRef },
      { key: "inclusions", ref: countriesRef },
      { key: "interestedSessionType", ref: sessionTypeRef },
    ];

    for (const field of fieldOrder) {
      if (errors[field.key] && field.ref.current) {
        field.ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
        const inputEl = field.ref.current.querySelector(
          "input, select, textarea, [tabindex='0'], [role='combobox']"
        );
        if (inputEl && typeof inputEl.focus === "function") {
          inputEl.focus();
        }
        break;
      }
    }
  };

  return (
    <Formik
      initialValues={stepTwoData}
      validate={(values) => {
        const errors = {};
        if (!values.mediumship_session_tools.length)
          errors.mediumship_session_tools = t("common:validation.required");
        if (!values.currentRoles) errors.currentRoles = t("common:validation.required");
        if (!values.screenName) errors.screenName = t("common:validation.required");
        if (!values.allowRecordings) errors.allowRecordings = t("common:validation.required");
        if (!values.interestedSessionType.length)
          errors.interestedSessionType = t("common:validation.required");
        if (
          values.wantToDoWork === "All Countries with Exclusions" &&
          !values.exclusions.length
        )
          errors.exclusions = t("common:validation.required");
        if (
          values.wantToDoWork === "Selected Countries only" &&
          !values.inclusions.length
        )
          errors.inclusions = t("common:validation.required");
        // if (!values.interestedSessionType1)
        //   errors.interestedSessionType1 = "Required";
        // if (!values.PaymentMethods) errors.PaymentMethods = "Required";
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        RunFunction(values);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        isSubmitting,
      }) => (
        <form
          onSubmit={(e) => {
            if (Object.keys(errors).length > 0) {
              showFormErrors(errors);
              focusFirstInvalidField(errors);
            }
            handleSubmit(e);
          }}
          className="tab-pane"
          role="tabpanel"
          id="step2"
        >
          <div className="row-one-step" ref={toolsRef}>
            <div className="full-side">
              <label>
                {t("preferences.specialTools")}<i>*</i>
              </label>
              <Select
                id="mediumship_session_tools"
                className="selection-box"
                options={newToolsData}
                multi={true}
                isMulti
                onChange={(value) => changeHandler(value, setFieldValue)}
                onBlur={handleBlur}
                placeholder={t("preferences.selectTools")}
                value={values.mediumship_session_tools}
                closeMenuOnSelect={false}
                closeMenuOnScroll={false}
              />
              {/* <select
                data-placeholder="Select Specialities"
                className="chosen-select"
                multiple
                tabindex="6"
              >
                <option>Verbal Prayer</option>
                <option>Tarot Cards</option>
                <option>Crystals</option>
                <option>Japanese</option>
                <option>Australia</option>
                <option>England</option>
                <option>south africa</option>
                <option>America</option>
              </select> */}
              {/* <span
                onClick={() => setOpenOtherLnaguages(!openOtherLnaguages)}
                className="other-lang pointer"
              >
                Other Language
              </span> */}
              {/* {openOtherLnaguages && (
                <TagsInput
                  value={values.otherLanguages}
                  className="form-other-tags-input"
                  name="otherLanguages"
                  onChange={(value) => setFieldValue("otherLanguages", value)}
                  placeHolder="Other Language"
                />
              )} */}
              {/* <span className="error">
                {errors.languages && touched.languages && errors.languages}
              </span> */}
            </div>
          </div>
          <div className="row-one-step" ref={rolesRef}>
            <div className="full-side">
              <div className="full-fild">
                <label>
                  {t("preferences.currentRoles")}
                   {/* (medium or coach) */}
                  <i>*</i>
                </label>
                <div className="check-field">
                  <input
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="medium"
                    type="checkbox"
                    value={1}
                    defaultChecked={values.currentRoles.includes(1)}
                    name="currentRoles"
                  />
                  <label htmlFor="my-check">{t("preferences.roles.medium")}</label>
                </div>
                <div className="check-field">
                  <input
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="coachtomedium"
                    value={2}
                    type="checkbox"
                    defaultChecked={values.currentRoles.includes(2)}
                    name="currentRoles"
                  />
                  <label htmlFor="my-checktow">
                    {t("preferences.roles.coachToMediums")}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row-one-step">
            <label>
              {t("preferences.screenNameLabel")}<i>*</i>
            </label>
            <input
              className={`${
                errors.screenName && touched.screenName && errors.screenName
                  ? "error-boundry"
                  : ""
              }`}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.screenName}
              disabled
              id="screenName"
              name="screenName"
              type="text"
              placeholder={t("preferences.screenNamePlaceholder")}
            />
            <h6>
              {t("preferences.screenNameHelp")}
            </h6>
            <div className="verification-code-section mt-2">
              <div className="d-flex">
                {requestChange && (
                  <input
                    onChange={handleChangeScreenNameHandler}
                    onBlur={handleBlur}
                    className="height-45 margin-right-30"
                    value={newScreenName}
                    type="text"
                    id="newScreenName"
                    name="newScreenName"
                    placeholder={t("preferences.screenNamePlaceholder")}
                  />
                )}
                <Button
                  status={0}
                  type="button"
                  className={`resend-btn w-unset height-45 min-width-130px`}
                  onClick={requestChangeHandler}
                  title={
                    requestChange
                      ? t("buttons.submit")
                      : t("buttons.requestChange")
                  }
                />
              </div>
              <div
                className={`text-left ${
                  requestChangeSuceessMessage === "Screen name is required"
                    ? "red"
                    : "green"
                }`}
              >
                {translateMessage(requestChangeSuceessMessage)}
              </div>
            </div>
          </div>
          <div className="row-one-step" ref={allowRecordingsRef}>
            <div className="full-fild">
              <label>{t("preferences.allowRecordings")}</label>
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={1}
                  type="radio"
                  defaultChecked={
                    parseInt(values.allowRecordings) === 1 ? true : false
                  }
                  name="allowRecordings"
                  id="allowRecordingsyes"
                />
                <label htmlFor="yes">{t("options.yes")}</label>
              </div>
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={0}
                  type="radio"
                  name="allowRecordings"
                  id="allowRecordingsno"
                  defaultChecked={
                    parseInt(values.allowRecordings) === 0 ? true : false
                  }
                />
                <label htmlFor="no">{t("options.no")}</label>
              </div>
            </div>
            <span className="error">
              {errors.allowRecordings && touched.allowRecordings && errors.allowRecordings}
            </span>
          </div>
          <div className="row-one-step">
            <div className="full-fild">
              <label>
                {t("preferences.wantToDoSessions")}
              </label>
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value="Other Mediums"
                  id="othermediums"
                  defaultChecked={
                    values.wantToDoSessions.includes("Other Mediums")
                      ? true
                      : false
                  }
                  type="checkbox"
                  name="wantToDoSessions"
                />
                <label htmlFor="my-check">
                  {t("preferences.sessionsWith.otherMediums")}
                </label>
              </div>
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value="Starter Clients"
                  defaultChecked={
                    values.wantToDoSessions.includes("Starter Clients")
                      ? true
                      : false
                  }
                  id="starterclient"
                  name="wantToDoSessions"
                  type="checkbox"
                />
                <label
                  htmlFor="my-checktow"
                  className="strclint tooltip-1-focus"
                >
                  {t("preferences.sessionsWith.starterClients")}
                </label>
                <span className="tooltip-1">
                  {t("preferences.sessionsWith.starterClientsTooltip")}
                </span>
              </div>
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value="Outreach Clients"
                  id="outreachclients"
                  type="checkbox"
                  defaultChecked={
                    values.wantToDoSessions.includes("Outreach Clients")
                      ? true
                      : false
                  }
                  name="wantToDoSessions"
                />
                <label
                  htmlFor="my-checktow"
                  className="strclint tooltip-2-focus"
                >
                  {t("preferences.sessionsWith.outreachClients")}
                </label>
                <span className="tooltip-2">
                  {t("preferences.sessionsWith.outreachClientsTooltip")}
                </span>
              </div>
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value="Paying Clients"
                  id="payingclient"
                  type="checkbox"
                  defaultChecked={
                    values.wantToDoSessions.includes("Paying Clients")
                      ? true
                      : false
                  }
                  name="wantToDoSessions"
                />
                <label htmlFor="my-checktow">
                  {t("preferences.sessionsWith.payingClients")}
                </label>
              </div>
            </div>
          </div>
          <div className="row-one-step">
            <div className="full-fild">
              <label>
                {t("preferences.wantToDoWork")}
              </label>
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value="All Countries"
                  id="allcountries"
                  defaultChecked={
                    values.wantToDoWork === "All Countries" ? true : false
                  }
                  name="wantToDoWork"
                  type="radio"
                />
                <label htmlFor="my-check">
                  {t("preferences.locations.allCountries")}
                </label>
              </div>
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value="All Countries with Exclusions"
                  id="exclusioncountries"
                  name="wantToDoWork"
                  defaultChecked={
                    values.wantToDoWork === "All Countries with Exclusions"
                      ? true
                      : false
                  }
                  type="radio"
                />
                <label htmlFor="my-checktow">
                  {t("preferences.locations.allWithExclusions")}
                </label>
              </div>
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value="Selected Countries only"
                  defaultChecked={
                    values.wantToDoWork === "Selected Countries only"
                      ? true
                      : false
                  }
                  id="selectedcountries"
                  name="wantToDoWork"
                  type="radio"
                />
                <label htmlFor="my-checktow">
                  {t("preferences.locations.selectedOnly")}
                </label>
              </div>
            </div>
          </div>

          {values.wantToDoWork !== "All Countries" &&
            values.wantToDoWork !== "" && (
              <div className="row-one-step" ref={countriesRef}>
                <div className="full-fild">
                  <label>
                    {values.wantToDoWork === "All Countries with Exclusions"
                      ? t("preferences.selectExclusions")
                      : t("preferences.selectCountries")}
                  </label>
                  <Select
                    id="country"
                    className="selection-box"
                    options={newCountryData}
                    multi={true}
                    isMulti
                    onChange={
                      values.wantToDoWork === "All Countries with Exclusions"
                        ? (value) => setFieldValue("exclusions", value)
                        : (value) => setFieldValue("inclusions", value)
                    }
                    onBlur={handleBlur}
                    placeholder={
                      values.wantToDoWork === "All Countries with Exclusions"
                        ? t("preferences.selectExclusion")
                        : t("preferences.selectCountry")
                    }
                    value={
                      values.wantToDoWork === "All Countries with Exclusions"
                        ? values.exclusions
                        : values.inclusions
                    }
                    closeMenuOnSelect={false}
                    closeMenuOnScroll={false}
                  />
                  <span className="error">
                    {errors.inclusions &&
                      touched.inclusions &&
                      errors.inclusions}
                    {errors.exclusions &&
                      touched.exclusions &&
                      errors.exclusions}
                  </span>
                </div>
              </div>
            )}
          {/* <div className="row-one-step">
            <div className="full-fild">
              <label>Select exclusions</label>
              <select
                data-placeholder="Select Country"
                className="chosen-select"
                multiple
                tabindex="6"
              >
                <option>United States</option>
                <option>Canada</option>
                <option>Russia</option>
                <option>Japanese</option>
                <option>Australia</option>
                <option>England</option>
                <option>south africa</option>
                <option>America</option>
              </select>
            </div>
          </div> */}
          <div className="row-one-step" ref={sessionTypeRef}>
            <div className="full-fild">
              <label>
                {t("preferences.sessionTypes")}
              </label>
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={1}
                  id="oneononemedium"
                  type="checkbox"
                  defaultChecked={
                    values.interestedSessionType.includes("1") ? true : false
                  }
                  name="interestedSessionType"
                />
                <label htmlFor="my-check">
                  {t("preferences.sessionTypeOptions.oneOnOne")}
                </label>
              </div>
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={2}
                  id="groupmedium"
                  type="checkbox"
                  defaultChecked={
                    values.interestedSessionType.includes("2") ? true : false
                  }
                  name="interestedSessionType"
                />
                <label htmlFor="my-checktow">
                  {t("preferences.sessionTypeOptions.group")}
                </label>
              </div>
            </div>
          </div>
          {parseInt(mediumshipLevel.mediumshipLevel) === 3 && (
            <div className="row-one-step as-medium">
              <div className="full-fild">
                <label>
                  {t("preferences.persona")} <i>*</i>
                </label>
                <div className="full">
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value="Would want name, photo, and full profile published"
                      id="profilepublised"
                      type="radio"
                      defaultChecked={
                        values.interestedSessionType1 ===
                        "Would want name, photo, and full profile published"
                          ? true
                          : false
                      }
                      name="interestedSessionType1"
                    />
                    <label htmlFor="my-check">
                      {t("preferences.personaOptions.full")}
                    </label>
                  </div>
                </div>
                <div className="full">
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value="Would want limited information published"
                      id="informationpublised"
                      type="radio"
                      defaultChecked={
                        values.interestedSessionType1 ===
                        "Would want limited information published"
                          ? true
                          : false
                      }
                      name="interestedSessionType1"
                    />
                    <label htmlFor="my-checktow">
                      {t("preferences.personaOptions.limited")}
                    </label>
                  </div>
                </div>
                <div className="full">
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value="Would want to start behind the scenes with nothing published"
                      id="nothingpublised"
                      defaultChecked={
                        values.interestedSessionType1 ===
                        "Would want to start behind the scenes with nothing published"
                          ? true
                          : false
                      }
                      type="radio"
                      name="interestedSessionType1"
                    />
                    <label htmlFor="my-checktow">
                      {t("preferences.personaOptions.nothing")}
                    </label>
                  </div>
                </div>
                <div className="full">
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value="Other"
                      id="otherpublished"
                      type="radio"
                      defaultChecked={
                        values.interestedSessionType1 === "Other" ? true : false
                      }
                      name="interestedSessionType1"
                    />
                    <label htmlFor="my-checktow">{t("options.other")}</label>
                  </div>
                </div>
              </div>
            </div>
          )}
          {mediumshipLevel.mediumshipLevel === "3" && (
            <div className="row-one-step payment-saction">
              <div className="full-fild">
                <label>
                  {t("preferences.paymentMethods")}
                </label>
                <div className="bookingpay">
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      defaultChecked={
                        values.PaymentMethods.includes(1) ? true : false
                      }
                      id="nopayment"
                      type="checkbox"
                      value={1}
                      name="PaymentMethods"
                    />
                    <label htmlFor="my-check">
                      {t("preferences.noPayments")}
                    </label>
                  </div>
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      defaultChecked={
                        values.PaymentMethods.includes(2) ? true : false
                      }
                      id="PayPal"
                      type="checkbox"
                      value={2}
                      name="PaymentMethods"
                    />
                    <label htmlFor="my-checktow">PayPal</label>
                  </div>
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="Stripe"
                      type="checkbox"
                      defaultChecked={
                        values.PaymentMethods.includes(3) ? true : false
                      }
                      value={3}
                      name="PaymentMethods"
                    />
                    <label htmlFor="my-checktow">Stripe</label>
                  </div>
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="Venmo"
                      type="checkbox"
                      value={4}
                      defaultChecked={
                        values.PaymentMethods.includes(4) ? true : false
                      }
                      name="PaymentMethods"
                    />
                    <label htmlFor="my-checktow">Venmo</label>
                  </div>
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="Cashapp"
                      type="checkbox"
                      defaultChecked={
                        values.PaymentMethods.includes(5) ? true : false
                      }
                      value={5}
                      name="PaymentMethods"
                    />
                    <label htmlFor="my-checktow">Cashapp</label>
                  </div>
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="Zelle"
                      type="checkbox"
                      defaultChecked={
                        values.PaymentMethods.includes(6) ? true : false
                      }
                      value={6}
                      name="PaymentMethods"
                    />
                    <label htmlFor="my-checktow">Zelle</label>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="row-one-step">
            <div className="full-fild">
              <label>
                {t("optIn.label")} <i>*</i>
              </label>
              <h4>
                {t("preferences.optInText")}
              </h4>
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value="Yes"
                  id="optin"
                  type="radio"
                  name="opt_in"
                  checked={values.opt_in === "Yes" ? true : false}
                />
                <label htmlFor="optin">{t("options.yes")}</label>
              </div>
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value="No"
                  id="optout"
                  type="radio"
                  name="opt_in"
                  checked={values.opt_in === "No" ? true : false}
                />
                <label htmlFor="optout">{t("options.no")}</label>
              </div>
            </div>
            <span className="error marg-top-55">
              {errors.opt_in && touched.opt_in && errors.opt_in}
            </span>
          </div>
          <div className="update mt-20 ">
            <button
              type="submit"
              className="update"
              onClick={() => {
                setFieldTouched("mediumship_session_tools", true, true);
                setFieldTouched("currentRoles", true, true);
                setFieldTouched("screenName", true, true);
                setFieldTouched("allowRecordings", true, true);
                setFieldTouched("interestedSessionType", true, true);
                if (values.wantToDoWork === "All Countries with Exclusions") {
                  setFieldTouched("exclusions", true, true);
                }
                if (values.wantToDoWork === "Selected Countries only") {
                  setFieldTouched("inclusions", true, true);
                }
              }}
            >
              {t("buttons.update")}
            </button>
          </div>
        </form>
      )}
    </Formik>
  );
}
